type DoctorLike = {nm_doctor?: string | null; ds_prefix?: string | null} | null | undefined

export function formatDoctorName(doctor: DoctorLike, fallback = '-'): string {
    if (!doctor?.nm_doctor) return fallback
    return doctor.ds_prefix ? `${doctor.ds_prefix} ${doctor.nm_doctor}` : doctor.nm_doctor
}
